import { storyblokEditable, StoryblokComponent } from "@storyblok/react";

function NavSearchContainer({ blok }) {
  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      {blok.body?.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
      {blok.footer?.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
    </div>
  );
}

export default NavSearchContainer;
